import {Box, ResultSubject, Span} from '../../../../styled';
import React from 'react';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import OfficeIcon from './OfficeIcon';

interface IOutlookTitle{
  title: string,
  sender: string,
}

const OutlookTitle = ({ title, sender }:IOutlookTitle) => (
  <Box>
    <ResultSubject>
      <Span>Subject: </Span>
      {title ? <HighlightMarker as='span'>{title}</HighlightMarker> : 'No Subject'}
      <Box width={30} display="inline-block">
        <OfficeIcon type="outlook" />
      </Box>
    </ResultSubject>
    <ResultSubject>
      <Span>From: </Span>
      {sender ? <HighlightMarker>{sender}</HighlightMarker> : 'No sender information'}
    </ResultSubject>
  </Box>
)

export default OutlookTitle;